/** Constant partner information
 *  The `Object.freeze()` method is used to make the object immutable, meaning that
 * its properties cannot be modified or deleted.
 */
const NewHomeSourcePartner = Object.freeze({
  partnerId: 1,
  partnerName: 'NewHomeSource',
  brandPartnerName: 'NewHomeSource',
});

export default NewHomeSourcePartner;
